import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { ClassificationGroupService, ClassificationGroupServiceImpl } from './service/classification-group.service';
import { ClassificationPopoverService, ClassificationPopoverServiceImpl } from './service/classification-popover.service'

export const classificationGroupModule = (bind: interfaces.Bind) => {
    bind(ClassificationGroupService).to(ClassificationGroupServiceImpl).inRequestScope();
    bind(ClassificationPopoverService).to(ClassificationPopoverServiceImpl).inRequestScope();
};
